<div cdkDropListGroup class="page-container">
  <div class="item-panel-container">
    <div class="top-item-container">
      <div class="top-items">
        <div class="heading">{{ panelTitle }}</div>
        @if (requiredWarning && !allRequired) {
          <mat-icon matTooltip="{{ warningTooltip }}" class="warning-icon"
            >info</mat-icon
          >
        }
      </div>

      <div class="filter-items">
        <form [formGroup]="form">
          <div class="filters">
            <mat-form-field style="padding-right: 31px">
              <mat-select
                (selectionChange)="onDepartmentChange($event)"
                name="department"
                placeholder="Departments"
                formControlName="deptControl"
              >
                @for (selection of departments; track selection) {
                  <mat-option [value]="selection.value">{{
                    selection.viewValue
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="cci-dropdown">
              <input
                matInput
                placeholder="CCI Codes"
                formControlName="cciCodeControl"
                [matAutocomplete]="cciAuto"
              />
              <mat-autocomplete
                #cciAuto="matAutocomplete"
                (optionSelected)="onCciCodeChange($event)"
              >
                @for (selection of filteredCciCodes; track selection) {
                  <mat-option [value]="selection.value">{{
                    selection.value
                  }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="filter-btns">
            <button
              type="button"
              [disabled]="!resetEnabled"
              matSuffix
              mat-icon-button
              class="reset-button"
              (click)="clearFilters()"
            >
              <mat-icon>replay</mat-icon>
            </button>
          </div>
        </form>
      </div>
    </div>

    <div class="panel-body">
      @if (searchBar || (searchBar && panelType === 2)) {
        <div class="search-bar">
          <mat-form-field subscriptSizing="dynamic" class="item-search">
            <input
              matInput
              [(ngModel)]="searchText"
              (ngModelChange)="onSearchInput()"
              placeholder="Search items..."
              (keydown.enter)="$event.preventDefault()"
            />
          </mat-form-field>
          @if (searchActive) {
            <button
              type="button"
              matSuffix
              mat-icon-button
              class="search-button"
              (click)="clearSearch()"
            >
              <mat-icon>clear</mat-icon>
            </button>
          } @else {
            <button
              type="submit"
              matSuffix
              mat-icon-button
              class="search-button"
              disabled
            >
              <mat-icon>search</mat-icon>
            </button>
          }
        </div>
        <div
          class="item-list"
          [cdkDropListSortingDisabled]="true"
          cdkDropList
          [id]="'parentList'"
          [cdkDropListData]="itemList"
        >
          @for (item of itemList; track item) {
            <div
              class="item-box"
              cdkDrag
              [cdkDragData]="item"
              [ngStyle]="{
                'background-color': checkTaskInUse(item.taskId)
                  ? '#C4C4C4'
                  : 'white',
              }"
            >
              <div
                class="item-name-text"
                #nameEl
                style="max-width: 350px"
                [matTooltip]="isOverflowing(nameEl) ? item.taskName : ''"
                matTooltipPosition="right"
                [innerHTML]="getDisplayTaskName(item)"
              ></div>
              <div class="item-icons">
                @if (panelType === 1) {
                  <mat-icon class="star-icon">star</mat-icon>
                }
                <mat-icon>menu</mat-icon>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="empty-text-side">
          <span style="width: 187px; text-align: center">{{
            this.panelTooltip
          }}</span>
        </div>
      }
    </div>
  </div>

  <div class="setup-container">
    @if (stationList.length > 0) {
      <div class="station-setup-area">
        @for (targetList of stationList; track targetList) {
          <div class="setup-list">
            <div class="station-setup-section">
              <button class="station-button" (click)="editStation(targetList)">
                {{ targetList.name }}
                <mat-icon>edit</mat-icon>
              </button>
              @if (!hasConfiguration) {
                <button
                  class="remove-button"
                  (click)="deleteStation(targetList)"
                  [disabled]="!checkEmptyStation(targetList)"
                >
                  <mat-icon style="height: 35px; width: 35px; font-size: 35px"
                    >close</mat-icon
                  >
                </button>
              }
            </div>
            @for (
              taskGroup of targetList.taskGroup;
              track taskGroup;
              let i = $index
            ) {
              <div class="task-group-container">
                <div
                  class="task-group-level"
                  cdkDropList
                  [cdkDropListData]="taskGroup.taskList"
                  (cdkDropListDropped)="drop($event)"
                >
                  <div class="setup-area">
                    @for (task of taskGroup.taskList; track task) {
                      <div class="item-box-setup" cdkDrag [cdkDragData]="task">
                        <div class="setup-item">
                          <div class="setup-list-name">
                            <mat-icon>menu</mat-icon>
                            <div
                              class="name-item"
                              #nameEl
                              [matTooltip]="
                                isOverflowing(nameEl) ? task.taskName : ''
                              "
                              matTooltipPosition="right"
                              [innerHTML]="getDisplayTaskName(task)"
                            ></div>
                          </div>
                          @if (task.taskType === 'Required') {
                            <mat-icon class="star-icon">star</mat-icon>
                          }
                        </div>
                        @if (
                          (panelType === 1 && task.taskType === 'Required') ||
                          (panelType === 2 &&
                            (task.taskType === 'AOC' ||
                              task.taskType === 'Optional'))
                        ) {
                          <button
                            class="remove-button"
                            (click)="deleteTask(targetList, task)"
                          >
                            <mat-icon>close</mat-icon>
                          </button>
                        }
                      </div>
                    }
                    @if (taskGroup.taskList.length === 0) {
                      <div class="setup-list-empty">
                        {{ this.itemConstants.emptyDropZoneText }}
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div class="empty-text-setup">
        <span style="width: 383px; text-align: center">{{
          this.setupTooltip
        }}</span>
      </div>
    }
    @if (!hasConfiguration) {
      <div class="station-container">
        <button class="station-button" (click)="addStation()">
          {{ this.itemConstants.addStationButtonText }}
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>
    }
  </div>
</div>
